import { createFileRoute, redirect } from "@tanstack/react-router"
import { BulkUpdateCreate } from "@/features/change-projects/components/BulkUpdateCreate"
import { canManageBulkUpdates } from "@/features/change-projects/core/access"

export const Route = createFileRoute("/(authenticated)/bulk-updates/new")({
  beforeLoad: ({ context }) => {
    if (!canManageBulkUpdates(context.user)) {
      throw redirect({ to: "/bulk-updates", replace: true })
    }
  },
  component: BulkUpdateCreate,
})
